"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var expo_linking_exports = {};
__export(expo_linking_exports, {
  addEventListener: () => addEventListener,
  createURL: () => createURL,
  getInitialURL: () => getInitialURL,
  parse: () => parse
});
module.exports = __toCommonJS(expo_linking_exports);
var createURL = function(path) {
  return `exp://localhost/${path}`;
};
var parse = function(url) {
  return {
    path: url
  };
};
var addEventListener = function() {
  return {
    remove: function() {
    }
  };
};
var getInitialURL = async function() {
  return null;
};
//# sourceMappingURL=expo-linking.js.map
